import { compose } from 'redux';
import actionTypes from './actionTypes';

const initialState = {
    isLoading: false,
    error: undefined
};
export default (state = initialState, action) => {
    switch(action.type){
    case actionTypes.LOAD_APP_DATA_START:
        return {
            ...state,
            isLoadingApp: true,
        };
    case actionTypes.LOAD_APP_DATA_SUCCESS:
        return {
            ...state,
            isLoadingApp: false,
        };
    case actionTypes.LOAD_APP_DATA_FAIL:
        return {
            ...state,
            isLoadingApp: false,
            error: action.payload.error
        };
    default: 
        return state;
    }
};